<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <path
      d="M20 3.535V13C20 13.7652 19.7077 14.5015 19.1827 15.0583C18.6578 15.615 17.9399 15.9501 17.176 15.995L17 16H3C2.23479 16 1.49849 15.7077 0.941739 15.1827C0.384993 14.6578 0.0498925 13.9399 0.00500011 13.176L0 13V3.535L9.445 9.832L9.561 9.898C9.69771 9.96479 9.84785 9.99951 10 9.99951C10.1522 9.99951 10.3023 9.96479 10.439 9.898L10.555 9.832L20 3.535Z"
      class="fill-current"
    />
    <path
      d="M17 0C18.08 0 19.027 0.57 19.555 1.427L10 7.797L0.445 1.427C0.695792 1.01982 1.04029 0.6785 1.44977 0.431489C1.85925 0.184479 2.32185 0.0389373 2.799 0.00699997L3 0H17Z"
      class="fill-current"
    />
  </svg>
</template>
